<div class="article-view-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>Article</h2>
    <div class="header-actions">
      <button mat-icon-button (click)="download()" matTooltip="Download">
        <mat-icon>download</mat-icon>
      </button>
      <button mat-icon-button (click)="copyArticle()" matTooltip="Copy full article">
        <mat-icon>content_copy</mat-icon>
      </button>
      <button mat-flat-button color="primary" (click)="onShare()" class="share-btn">Share</button>
      <button mat-icon-button (click)="close()" aria-label="Close" cdkFocusInitial>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content>
    @if (loading) {
      <div class="loading-block">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading article…</p>
      </div>
    } @else if (error) {
      <div class="error-block">{{ error }}</div>
    } @else {
      <!-- Ready to rank -->
      @if (seoScore != null) {
        <div class="ready-to-rank">
          <div class="score-circle" [class.high]="seoScore >= 70" [class.medium]="seoScore >= 50 && seoScore < 70" [class.low]="seoScore < 50">
            {{ seoScore }}%
          </div>
          <div class="score-text">
            <strong>Ready to rank</strong>
            <p>You can expect high visibility with your article.</p>
          </div>
        </div>
      }

      <!-- Title Tag and Meta Description -->
      <div class="seo-section">
        <h4 class="seo-section-title">Title Tag and Meta Description</h4>
        <div class="seo-fields">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Title Tag</mat-label>
            <input matInput [(ngModel)]="titleTag" readonly>
            <mat-hint>{{ titleTagCount }}/60</mat-hint>
            <button mat-icon-button matSuffix (click)="copyArticle()" matTooltip="Copy full article">
              <mat-icon>content_copy</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Meta Description</mat-label>
            <textarea matInput [(ngModel)]="metaDescription" readonly rows="3"></textarea>
            <mat-hint>{{ metaDescriptionCount }}/150</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <!-- Article content -->
      <div class="article-body">
        <!-- <h3 class="article-title">{{ title }}</h3> -->
        @if (contentHtml) {
          <div class="article-content" [innerHTML]="contentHtml" contenteditable="false"></div>
        }
      </div>
    }
  </mat-dialog-content>
</div>
